import importerReducers from 'src/modules/shared/importer/importerReducers';
import actions from 'src/modules/employeeCategory/importer/employeeCategoryImporterActions';

export default importerReducers(actions);
